// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import iView from 'iview';
import 'iview/dist/styles/iview.css'
import '@/common/common.scss'

// import { 
//         Button , Form , FormItem , Input 
//     } from 'iview';

// Vue.component('Button', Button);
// Vue.component('Form', Form);
// Vue.component('FormItem', FormItem);
// Vue.component('Input', Input);

import {
  Modal, Carousel
} from 'iview';
Vue.component('Modal', Modal);
Vue.component('Carousel', Carousel);
Vue.prototype.$Modal = Modal;
Vue.use(iView);

Vue.config.productionTip = false;

let setPageTitle = (title)=>{
    let t = title || '猎上网';
    window.document.title = t;
};

router.beforeEach((to, from, next) => {
    setPageTitle(to.meta.title);
    //LoadingBar.start();
    next();
});

router.afterEach(route => {
    //LoadingBar.finish();
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/modules/login/index.js